export default Object.freeze({
  Both: 'BOTH',
  Domestic: 'DOM',
  International: 'INT',
})
